import React from "react";
import { MessageDescriptor } from "react-intl";

import {
	ButtonGroup,
	ButtonGroupItem
} from "src/common/components/ButtonGroup";
import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import {
	useLogProp,
	useMessageProps,
	useValue
} from "src/features/forms/hooks/useField";
import { ButtonGroupProps } from "src/features/forms/types";

export const ButtonGroupRenderer: React.FunctionComponent<ButtonGroupProps> = ({
	labels,
	...directProps
}) => {
	const isLocked = React.useContext(IsLockedContext);
	const options = useOptions(labels);
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<ButtonGroup {...directProps} disabled={isLocked}>
			{options.map(option => (
				<ButtonGroupItem
					key={option.value}
					checked={value === option.value}
					value={option.value}
					onChangeValue={onChangeValue}
				>
					{option.label}
				</ButtonGroupItem>
			))}
		</ButtonGroup>
	);
};

function useOptions(messages: {
	[key: string]: MessageDescriptor;
}): { label: string; value: string }[] {
	const formatMessage = useFormatMessageMap();
	const messageProps = useMessageProps();
	const values = useLogProp<string[]>(messageProps, "values", []);
	return React.useMemo(
		() =>
			values.map(value => ({
				label: formatMessage(messages, value),
				value
			})),
		[messages, values, formatMessage]
	);
}
